var React = require('react');

function IcNuoroda (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic_nuoroda","transform":"translate(1 1)"},[React.createElement("path",{"id":"Path_49","data-name":"Path 49","d":"M6.958,0H3.036A3.036,3.036,0,0,0,0,3.036v14.17a3.036,3.036,0,0,0,3.036,3.036h14.17a3.036,3.036,0,0,0,3.036-3.036V13.314","fill":"#fff","stroke":"#d4e1ff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_7","data-name":"Line 7","x1":"13.158","y2":"13.158","transform":"translate(6.579 0.506)","fill":"none","stroke":"#d4e1ff","strokeWidth":"2","key":1}),React.createElement("path",{"id":"Path_50","data-name":"Path 50","d":"M1549.015,556.121V546.029h-9.969","transform":"translate(-1528.819 -546)","fill":"none","stroke":"#d4e1ff","strokeLinejoin":"bevel","strokeWidth":"2","key":2})]));
}

IcNuoroda.defaultProps = {"width":"22.243","height":"22.243","viewBox":"0 0 22.243 22.243"};

module.exports = IcNuoroda;

IcNuoroda.default = IcNuoroda;
